import * as React from "react"
import { Link, useTranslation } from "@zestia/gatsby-plugin-react-i18next"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import G2Stars from "@/components/svg/G2StarsOrange"

const CenteredHero = ({
  backgroundClass = "",
  kickerText,
  title,
  titleClass = "h1--xl",
  text,
  textClass = "p--lg mb-6",
  logo,
  g2StarsKicker = false,
  centered = "false",
  showButton = "false",
  buttonText,
  buttonClass,
  buttonLink = "/signup/",
  secondaryButton,
  wrapperClass = "",
  headerImage,
}) => {
  const { t } = useTranslation()
  return (
    <header className={`page-header ${backgroundClass}`}>
      <div
        className={`container-fluid row ${
          centered === "true" ? "center-xs" : ""
        }`}
      >
        <div
          className={`col-xs-12 col-sm-10 col-md-7 col-lg-10 pb-20 primary-header__content ${wrapperClass} `}
        >
          {g2StarsKicker && (
            <div className="g2-rating center-xs">
              <G2Stars />
              <span className="g2-rating--text">
                {t("home.header.g2-rating")}
              </span>
            </div>
          )}
          {kickerText && (
            <span
              className={`heading-kicker heading-kicker--no-status pt-10 md:pt-0 ${centered === "true" ? "center-xs" : ""}`}
            >
              {kickerText}
            </span>
          )}
          {logo && <img src={logo} alt="Logo" className="logo" />}
          <h1
            className={`${centered === "true" ? "mb-6" : ""} ${titleClass} h1--xl-condensed`}
          >
            {title}
          </h1>
          {text && <p className={textClass}>{text}</p>}
          {showButton === "true" && (
            <Link to={buttonLink} className={buttonClass || "btn"}>
              {buttonText || t("common.try-free-14-days")}
            </Link>
          )}
          {secondaryButton && (
            <Link to={secondaryButton.link} className={"btn btn--ghost ml-2"}>
              {secondaryButton.text}
            </Link>
          )}

          {headerImage && (
            <GatsbyImage
              image={getImage(headerImage)}
              alt=""
              role="presentation"
            />
          )}
        </div>
      </div>
    </header>
  )
}

export default CenteredHero
